import $ from 'jquery';


function ApplicationSubmit() {
  this.$target = $('form');

  this.submit = this.submit.bind(this);

  this.init();
}

ApplicationSubmit.prototype.init = function () {
  this.$target.on('submit', this.submit);
}

ApplicationSubmit.prototype.submit = function (e) {
  const $error = $('div.error')
  const self = this;
  $error.remove();
  $('.error-wrap').removeClass('error-wrap');

  self.validate();
  if (0 < $('div.error').length) {
    var offset = $('div.error:first').offset();
    if (typeof offset !== 'undefined') {

      $('html, body').animate({
        scrollTop: offset.top - 180
      }, 'fast');
    }

    $('.kai-table').find('td').removeClass('error-wrap');
    $('div.error').parents('.cell-10').addClass('error-wrap');
    $('div.error').stop().show('slow');

    return false;
  }
}

ApplicationSubmit.prototype.validate = function () {
  const self = this;

  $('input[type="number"]').filter('.validate').each(function() {
    const $this = $(this);

    self.validRequired($this);
  });
  $(':text, textarea').filter('.validate').each(function () {
    const $this = $(this);

    self.validRequired($this);
    self.validEmail($this);
    self.validTelHyphen($this);
  });

  self.validTourokuCheck();
  self.validSelectbox();
  self.validRadiobox();
  self.validCheckbox();
}

ApplicationSubmit.prototype.validString = function (str) {
  return '<div class="error"><span>' + str + '</span></div>';
}

ApplicationSubmit.prototype.validRequired = function (elem) {
  const self = this;
  elem.filter('.required').each(function () {
    if ($(this).val() == '' && $(this).prop('disabled') === false) {
      $(this).parents('.cell-10').append(self.validString('必須項目です'))
    }
  })
}

ApplicationSubmit.prototype.validEmail = function (elem) {
  const self = this;
  elem.filter('.vali-mail').each(function () {
    if ($(this).val() && !$(this).val().match(/.+@.+\..+/g)) {
      $(this).parents('.cell-10').append(self.validString('メールアドレスの形式が異なります'))
    }
  })
}

ApplicationSubmit.prototype.validTelHyphen = function (elem) {
  const self = this;
  elem.filter('.vali-tel').each(function () {
    if ($(this).val() && !$(this).val().match(/\-/)) {
      $(this).parents('.cell-10').append(self.validString('ハイフンが入力されていません'))
    }
  })
}

ApplicationSubmit.prototype.validTourokuCheck = function () {
  const self = this;
  $('.tourokuCheck').each(function () {
    if ($(':checkbox:checked', this).length == 0) {
      $(this).append(self.validString('項目にチェックしてください'))
    }
  })
}

ApplicationSubmit.prototype.validSelectbox = function () {
  const self = this;
  $('select').filter('.validate').each(function () {
    $(this).filter('.required').each(function () {
      if ($(this).val() == '') {
        $(this).parents('.cell-10').append(self.validString('選択されていません'))
      }
    })
  })
}

ApplicationSubmit.prototype.validRadiobox = function () {
  const self = this;
  let kaijouFlag = false;
  $(':radio').filter('.validate').each(function () {
    $(this).filter('.required').each(function () {
      const name = $(this).attr('name');
      const dataJukou = $(this).data('jukou');
      if (dataJukou) {
        $('input[data-kyousitsu]').each(function () {
          const val = $(this).val();
          const not = $(this).data('not');
          // if (val == '埼玉' || val == '東京') {
          if (not == 'disable') {
            return;
          }
          if ($(this).prop('disabled')) {
            kaijouFlag = true;
          }
        });
        console.log(kaijouFlag)
      }

      if (kaijouFlag) {
        if (0 !== $('input[name="' + name + '"]:disabled').length) return;
      }
      if ($('input[name="' + name + '"]:checked').length == 0) {
        if (0 < $(this).parents('.form-group').find('div.error').length) return false;
        $(this).parents('.cell-10').append(self.validString('チェックされていません'))
      }
    })
  })
}

ApplicationSubmit.prototype.validCheckbox = function () {
  const self = this;
  $('.checkRequired').each(function () {
    if (0 !== $(':checkbox:disabled', this).length) return;
    if ($(':checkbox:checked',this).length == 0) {
      $(this).append(self.validString('チェックされていません'));
    }
  })
}

export default ApplicationSubmit;